import React from 'react';
import { useQuery } from '@apollo/client';
import { Skeleton, Stack } from '@mui/material';
import PlayTodayRoutineCard from 'components/play/PlayTodayRoutineCard';
import PlayRestDayPanel from 'components/play/PlayRestDayPanel';
import { MY_WEEKLY_ROUTINE } from 'api/graphql/play';
import { itemsOfDay, todayIso } from 'components/play/constants';

/**
 * OTRIX Play — "Entrenamiento" SIN una sesión en curso.
 *
 * Es la pantalla que se ve al entrar por el menú: muestra lo que toca HOY y deja arrancarlo.
 * Si hoy no hay entrenamiento, no se queda en blanco: ofrece recuperación (respiración/yoga)
 * con tiempo controlado.
 */
function PlayWorkoutIdle() {
  const { data, loading } = useQuery(MY_WEEKLY_ROUTINE, { fetchPolicy: 'cache-and-network' });

  if (loading && !data) {
    return (
      <Stack spacing={2}>
        <Skeleton variant="rounded" height={200} sx={{ borderRadius: 3 }} />
        <Skeleton variant="rounded" height={120} sx={{ borderRadius: 3 }} />
      </Stack>
    );
  }

  const todayItems = itemsOfDay(data?.myWeeklyRoutine?.items || [], todayIso());

  return todayItems.length > 0 ? <PlayTodayRoutineCard /> : <PlayRestDayPanel />;
}

export default PlayWorkoutIdle;
